import script from "./Granted.vue?vue&type=script&lang=ts&setup=true"
export * from "./Granted.vue?vue&type=script&lang=ts&setup=true"

import "./Granted.vue?vue&type=style&index=0&id=742160ab&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-742160ab"]])

export default __exports__